import { CampaignType } from "@vviinn/user-managment-client-ts";

export const isCampaignType = (campaignType?: CampaignType) => {
  return {
    isVpdCampaign: campaignType === "VPD",
    isVpsCampaign: campaignType === "VPS",
    isTextSearchCampaign: campaignType === "TEXT_SEARCH",
    isVprOrVpcCampaign: campaignType === "VPC" || campaignType === "VPR",
  };
};
